import { render, staticRenderFns } from "./PasswordChangeBtn.vue?vue&type=template&id=33cd9aa8&"
import script from "./PasswordChangeBtn.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports